import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { formatTimestamp } from "../../lib";

const VERB: Record<string, string> = {
  drafted: "drafted",
  updated: "updated",
  posted: "posted",
  claimed: "claimed",
  cancelled: "cancelled",
  expired: "expired",
};

function describeActivity(row: {
  event_type: string | null;
  actor_name: string | null;
  school_name: string | null;
}): string {
  const school = row.school_name || "an unknown school";
  // 'expired' is intransitive — read better without an actor subject.
  if (row.event_type === "expired") {
    return `A job at ${school} expired`;
  }
  const actor = row.actor_name || "Someone";
  const verb = row.event_type ? VERB[row.event_type] : null;
  if (!verb) return `${actor} changed a job at ${school}`;
  return `${actor} ${verb} a job at ${school}`;
}

// returns: array of latest 10 job_activity rows, each with
//   { ...row, school: { label, value } | null, f_created_at, f_activity }
export const recent_job_activity: Query<Ctx> = async ({ sb }, _params) => {
  const { data } = await sb
    .from("v_recent_job_activity")
    .select("*")
    .order("created_at", { ascending: false })
    .limit(10);
  if (!data) return [];

  return data.map((row: any) => ({
    ...row,
    school: row.school_id
      ? { label: row.school_name, value: row.school_id }
      : null,
    f_created_at: formatTimestamp(row.created_at),
    f_activity: describeActivity(row),
  }));
};
